export const getContainer = param => {
    // check if given container is element
    if (typeof param === 'string') {
        return document.querySelector(param);
    }

    return param;
};